import React from 'react';

import { withFilterCars } from './../../../shared/containers/containerFilterCars'
import Icon from './../../../shared/items/static/icon'
import Input from './../../../shared/items/contols/input'

import styles from './searchCarsString.module.scss'

const SearchCarsString = props => {
  const { onHandleChangeStore, filterCarsListItems } = props

  return (
    <div className={styles.searchCars}>
      <Input
        name="searchTerm"
        type="text"
        store={filterCarsListItems}
        handleChangeStore={onHandleChangeStore}
        placeholder="Поиск"
        defaultValue={filterCarsListItems.searchTerm}
      />
      <div className={styles.container_searchBtn}>
        <Icon name="search" />
      </div>
    </div>
  )
}

export default withFilterCars(React.memo(SearchCarsString))
